/**
 * Whether keystrokes go to a text field: an input, a textarea, editable content,
 * an element typing through the EditContext API (Monaco does in Chromium), or
 * anything inside an element marked `data-captures-keys` (the strategy editor).
 * Page-wide hotkeys (type-to-search, drawing tools) leave those alone.
 */
export const isTypingIn = (element: Element | null): boolean => {
  if (element === null) return false
  if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement || element instanceof HTMLSelectElement) return true
  if (element instanceof HTMLElement && (element.isContentEditable || ("editContext" in element && element.editContext != null))) return true
  return element.closest("[data-captures-keys]") !== null
}
